const SAMPLE_FLASHCARDS = [
  {
    id: 1,
    category: "React",
    subcategory: "React Basics",
    question: "What is React?",
    answer: "A library for managing user interfaces",
    options: [
      "A library for managing user interfaces",
      "A JavaScript framework for backend development",
      "A CSS pre-processor",
      "A database query language",
    ],
  },
  {
    id: 2,
    category: "CCNA",
    subcategory: "OSI Model",
    question: "What does OSI stand for?",
    answer: "Open Systems Interconnection",
    options: [
      "Open Systems Interconnection",
      "Operating System Interface",
      "Optimal Signal Indicator",
      "Organized System Integration",
    ],
  },
  {
    id: 3,
    category: "CCNA",
    subcategory: "OSI Model",
    question: "Which layer of the OSI model deals with routing?",
    answer: "Network Layer",
    options: [
      "Data Link Layer",
      "Network Layer",
      "Transport Layer",
      "Application Layer",
    ],
  },
  {
    id: 4,
    category: "CCNA",
    subcategory: "IP Addressing",
    question: "What is the default subnet mask for a Class C IP address?",
    answer: "255.255.255.0",
    options: ["255.0.0.0", "255.255.0.0", "255.255.255.0", "255.255.255.255"],
  },
  {
    id: 5,
    category: "CCNA",
    subcategory: "Networking Protocols",
    question: "Which protocol is used for sending email?",
    answer: "SMTP",
    options: ["HTTP", "FTP", "SMTP", "SNMP"],
  },
  {
    id: 6,
    category: "CCNA",
    subcategory: "Networking Concepts",
    question: "What is the purpose of a VLAN?",
    answer: "To segment a network",
    options: [
      "To create a virtual environment",
      "To encrypt data packets",
      "To segment a network",
      "To prioritize network traffic",
    ],
  },
  {
    id: 7,
    category: "React",
    subcategory: "React Basics",
    question: "What is JSX?",
    answer: "JavaScript XML",
    options: [
      "JavaScript Extension",
      "JavaScript XML",
      "JavaScript X-Path",
      "JavaScript JSON",
    ],
  },
  {
    id: 8,
    category: "React",
    subcategory: "React Hooks",
    question: "Which hook is used for side-effects?",
    answer: "useEffect",
    options: ["useState", "useEffect", "useContext", "useReducer"],
  },
  {
    id: 9,
    category: "React",
    subcategory: "State Management",
    question: "What is Redux?",
    answer: "A state management library",
    options: [
      "A JavaScript framework",
      "A state management library",
      "A CSS framework",
      "A backend library",
    ],
  },
  {
    id: 10,
    category: "React",
    subcategory: "Routing",
    question: "What is React Router?",
    answer: "A routing library for React",
    options: [
      "A state management library",
      "A routing library for React",
      "A CSS framework",
      "A backend library",
    ],
  },
  {
    id: 11,
    category: "React",
    subcategory: "React Basics",
    question: "What is a React component?",
    answer: "A reusable piece of UI",
    options: [
      "A function",
      "A reusable piece of UI",
      "An HTML element",
      "A JavaScript object",
    ],
  },
  {
    id: 12,
    category: "React",
    subcategory: "React Basics",
    question: "What is React's virtual DOM?",
    answer: "An in-memory representation of the real DOM elements",
    options: [
      "A physical DOM",
      "An in-memory representation of the real DOM elements",
      "A set of APIs",
      "A database",
    ],
  },
  {
    id: 13,
    category: "React",
    subcategory: "React Basics",
    question: "What is a React Fragment?",
    answer: "A way to return multiple elements",
    options: [
      "A way to return multiple elements",
      "A type of component",
      "A loop",
      "A conditional rendering method",
    ],
  },
  {
    id: 14,
    category: "React",
    subcategory: "React Basics",
    question: "What is a React Portal?",
    answer:
      "A way to render children into a DOM node that exists outside the DOM hierarchy",
    options: [
      "A way to render children into a DOM node that exists outside the DOM hierarchy",
      "A type of component",
      "A loop",
      "A conditional rendering method",
    ],
  },
  {
    id: 15,
    category: "React",
    subcategory: "React Basics",
    question: "What is Context in React?",
    answer:
      "A way to pass data through the component tree without having to pass props down manually",
    options: [
      "A way to pass data through the component tree without having to pass props down manually",
      "A type of component",
      "A loop",
      "A conditional rendering method",
    ],
  },
  {
    id: 16,
    category: "React",
    subcategory: "React Basics",
    question: "What is a React Hook?",
    answer:
      "A function that lets you use state and other React features without writing a class",
    options: [
      "A function that lets you use state and other React features without writing a class",
      "A type of component",
      "A loop",
      "A conditional rendering method",
    ],
  },
  {
    id: 17,
    category: "CCNA",
    subcategory: "IP Addressing",
    question: "What is the range of private IP addresses for Class A?",
    answer: "10.0.0.0 to 10.255.255.255",
    options: [
      "10.0.0.0 to 10.255.255.255",
      "172.16.0.0 to 172.31.255.255",
      "192.168.0.0 to 192.168.255.255",
      "None of the above",
    ],
  },
  {
    id: 18,
    category: "CCNA",
    subcategory: "Networking Protocols",
    question: "What is NAT? (Network Address Translation)",
    answer: "Network Address Translation",
    options: [
      "Network Address Translation",
      "Network Allocation Table",
      "Network Access Token",
      "None of the above",
    ],
  },
  {
    id: 19,
    category: "CCNA",
    subcategory: "Networking Concepts",
    question: "What is a firewall used for?",
    answer: "To control incoming and outgoing network traffic",
    options: [
      "To filter spam emails",
      "To control incoming and outgoing network traffic",
      "To improve Wi-Fi signal strength",
      "To encrypt data",
    ],
  },
  {
    id: 20,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is Python?",
    answer: "A high-level programming language",
    options: [
      "A type of snake",
      "A high-level programming language",
      "A data storage format",
      "A computer manufacturer",
    ],
  },
  {
    id: 21,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is the main use of Python?",
    answer: "Web development, data analysis, artificial intelligence, and more",
    options: [
      "Web development",
      "Data analysis",
      "Artificial intelligence",
      "All of the above",
    ],
  },
  {
    id: 22,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is the PEP 8 style guide for Python?",
    answer: "A set of conventions for writing Python code",
    options: [
      "A type of snake",
      "A computer manufacturer",
      "A set of conventions for writing Python code",
      "A Python package",
    ],
  },
  {
    id: 23,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is the purpose of indentation in Python?",
    answer: "To indicate blocks of code",
    options: [
      "To make the code look pretty",
      "To indicate blocks of code",
      "To create comments",
      "To import libraries",
    ],
  },
  {
    id: 24,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is a Python variable?",
    answer: "A symbolic name for a value",
    options: [
      "A data structure",
      "A symbolic name for a value",
      "A Python module",
      "A reserved keyword",
    ],
  },
  {
    id: 25,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is a Python function?",
    answer: "A reusable block of code",
    options: [
      "A type of variable",
      "A Python module",
      "A reusable block of code",
      "A reserved keyword",
    ],
  },
  {
    id: 26,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is a Python list?",
    answer: "An ordered collection of items",
    options: [
      "An ordered collection of items",
      "A Python module",
      "A reserved keyword",
      "A type of loop",
    ],
  },
  {
    id: 27,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is a Python dictionary?",
    answer: "A collection of key-value pairs",
    options: [
      "A collection of key-value pairs",
      "A Python module",
      "A reserved keyword",
      "A type of loop",
    ],
  },
  {
    id: 28,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is a Python class?",
    answer: "A blueprint for creating objects",
    options: [
      "A blueprint for creating objects",
      "A Python module",
      "A reserved keyword",
      "A type of loop",
    ],
  },
  {
    id: 29,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is a Python module?",
    answer: "A file containing Python code",
    options: [
      "A blueprint for creating objects",
      "A file containing Python code",
      "A reserved keyword",
      "A type of loop",
    ],
  },
  {
    id: 30,
    category: "Python",
    subcategory: "Python Basics",
    question: "What is a Python package?",
    answer: "A collection of Python modules",
    options: [
      "A file containing Python code",
      "A collection of Python modules",
      "A reserved keyword",
      "A type of loop",
    ],
  },
  {
    id: 31,
    category: "Django",
    subcategory: "Django Basics",
    question: "What is Django?",
    answer: "A high-level Python web framework",
    options: [
      "A type of snake",
      "A high-level Python web framework",
      "A data storage format",
      "A computer manufacturer",
    ],
  },
  {
    id: 32,
    category: "Django",
    subcategory: "Django Basics",
    question: "What is the main use of Django?",
    answer: "Building web applications",
    options: [
      "Building web applications",
      "Data analysis",
      "Artificial intelligence",
      "All of the above",
    ],
  },
  {
    id: 33,
    category: "Django",
    subcategory: "Django Basics",
    question: "What is the Django ORM?",
    answer: "Object-Relational Mapping",
    options: [
      "Object-Relational Mapping",
      "Object-Relational Database",
      "Object-Relational Model",
      "None of the above",
    ],
  },
  {
    id: 34,
    category: "Django",
    subcategory: "Django Basics",
    question: "What is a Django model?",
    answer: "A Python class that represents a database table",
    options: [
      "A Python function",
      "A Python class that represents a database table",
      "A Python module",
      "A reserved keyword",
    ],
  },
  {
    id: 35,
    category: "Django",
    subcategory: "Django Basics",
    question: "What is a Django view?",
    answer:
      "A Python function that takes a web request and returns a web response",
    options: [
      "A Python class",
      "A Python function that takes a web request and returns a web response",
      "A Python module",
      "A reserved keyword",
    ],
  },
  {
    id: 36,
    category: "Django",
    subcategory: "Django Basics",
    question: "What is a Django template?",
    answer: "A text file containing HTML and template tags",
    options: [
      "A Python function",
      "A text file containing HTML and template tags",
      "A Python module",
      "A reserved keyword",
    ],
  },
  {
    id: 37,
    category: "Django",
    subcategory: "Django Basics",
    question: "What is a Django URL pattern?",
    answer: "A regular expression that maps to a view function",
    options: [
      "A Python class",
      "A regular expression that maps to a view function",
      "A Python module",
      "A reserved keyword",
    ],
  },

  {
    id: 38,
    category: "CCNA",
    subcategory: "Network Protocols",
    question: "What is the main difference between TCP and UDP?",
    answer: "TCP is connection-oriented, UDP is connectionless",
    options: [
      "TCP is faster than UDP",
      "TCP is connection-oriented, UDP is connectionless",
      "TCP uses IP, UDP uses ICMP",
      "None of the above",
    ],
  },
  {
    id: 39,
    category: "CCNA",
    subcategory: "Network Protocols",
    question: "What port does UDP use for DNS queries?",
    answer: "53",
    options: ["53", "80", "443", "8080"],
  },
  {
    id: 40,
    category: "CCNA",
    subcategory: "Switching",
    question: "Which STP state immediately follows the blocking state?",
    answer: "Listening",
    options: ["Listening", "Learning", "Forwarding", "Disabled"],
  },
  {
    id: 41,
    category: "CCNA",
    subcategory: "Wireless Networking",
    question: "What wireless standard operates at 5GHz frequency?",
    answer: "802.11a",
    options: ["802.11a", "802.11b", "802.11g", "802.11n"],
  },
  {
    id: 42,
    category: "CCNA",
    subcategory: "Wireless Security",
    question: "What is the purpose of WPA in a wireless network?",
    answer: "To provide security through encryption",
    options: [
      "To provide security through encryption",
      "To boost signal strength",
      "To provide routing services",
      "None of the above",
    ],
  },
  {
    id: 43,
    category: "CCNA",
    subcategory: "Switching",
    question: "What is the default STP priority?",
    answer: "32768",
    options: ["1024", "4096", "32768", "65536"],
  },
  {
    id: 44,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the maximum hop count for OSPF?",
    answer: "Infinite",
    options: ["15", "16", "Infinite", "None of the above"],
  },
  {
    id: 45,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the 'show ip ospf neighbor' command?",
    answer: "To display OSPF neighbor information",
    options: [
      "To display OSPF routes",
      "To display OSPF neighbor information",
      "To display OSPF settings",
      "None of the above",
    ],
  },
  {
    id: 46,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the OSPF Router ID format?",
    answer: "32-bit number",
    options: [
      "16-bit number",
      "32-bit number",
      "48-bit number",
      "64-bit number",
    ],
  },
  {
    id: 47,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the default hello interval for OSPF?",
    answer: "10 seconds",
    options: ["5 seconds", "10 seconds", "30 seconds", "60 seconds"],
  },
  {
    id: 48,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the OSPF DR (Designated Router)?",
    answer: "To optimize OSPF network traffic",
    options: [
      "To optimize OSPF network traffic",
      "To act as a backup router",
      "To encrypt OSPF packets",
      "None of the above",
    ],
  },
  {
    id: 49,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the 'cost' in OSPF?",
    answer: "To determine the best path for data packets",
    options: [
      "To determine the best path for data packets",
      "To set the priority of a router",
      "To encrypt OSPF packets",
      "None of the above",
    ],
  },
  {
    id: 50,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the OSPF LSA (Link-State Advertisement)?",
    answer: "To advertise routing information",
    options: [
      "To advertise routing information",
      "To encrypt OSPF packets",
      "To set the priority of a router",
      "None of the above",
    ],
  },
  {
    id: 51,
    category: "CCNA",
    subcategory: "OSPF",
    question:
      "What is the default OSPF hello interval on a point-to-point network?",
    answer: "10 seconds",
    options: ["5 seconds", "10 seconds", "30 seconds", "60 seconds"],
  },
  {
    id: 52,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the OSPF network command used for?",
    answer: "To specify which interfaces will participate in OSPF",
    options: [
      "To specify which interfaces will participate in OSPF",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 53,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the OSPF 'area range' command?",
    answer: "To summarize routes at an area boundary",
    options: [
      "To summarize routes at an area boundary",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 54,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the 'show ip ospf interface' command?",
    answer: "To display OSPF-related interface information",
    options: [
      "To display OSPF routes",
      "To display OSPF-related interface information",
      "To display OSPF settings",
      "None of the above",
    ],
  },
  {
    id: 55,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the OSPF RID (Router ID) used for?",
    answer: "To uniquely identify a router in an OSPF network",
    options: [
      "To uniquely identify a router in an OSPF network",
      "To set OSPF priority",
      "To encrypt OSPF packets",
      "None of the above",
    ],
  },
  {
    id: 56,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the OSPF 'network' command?",
    answer: "To enable OSPF on specified interfaces",
    options: [
      "To enable OSPF on specified interfaces",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 57,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the OSPF 'passive-interface' command?",
    answer: "To prevent OSPF updates from being sent out an interface",
    options: [
      "To prevent OSPF updates from being sent out an interface",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 58,
    category: "CCNA",
    subcategory: "OSPF",
    question:
      "What is the purpose of the OSPF 'default-information originate' command?",
    answer: "To generate a default route into OSPF",
    options: [
      "To generate a default route into OSPF",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 59,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the OSPF 'area' command?",
    answer: "To assign an interface to a specific OSPF area",
    options: [
      "To assign an interface to a specific OSPF area",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 60,
    category: "CCNA",
    subcategory: "OSPF",
    question: "What is the purpose of the OSPF 'router-id' command?",
    answer: "To manually set the OSPF router ID",
    options: [
      "To manually set the OSPF router ID",
      "To set OSPF priority",
      "To encrypt OSPF packets",
      "None of the above",
    ],
  },
  {
    id: 61,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question: "What is the purpose of the OSPF 'redistribute' command?",
    answer: "To inject routes from another routing protocol into OSPF",
    options: [
      "To inject routes from another routing protocol into OSPF",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 62,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question: "What is the purpose of the OSPF 'summary-address' command?",
    answer: "To manually configure OSPF route summarization",
    options: [
      "To manually configure OSPF route summarization",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 63,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question: "What is the purpose of the OSPF 'timers' command?",
    answer: "To manually set OSPF hello and dead intervals",
    options: [
      "To manually set OSPF hello and dead intervals",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 73,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question: "What is the purpose of the OSPF 'virtual-link' command?",
    answer: "To configure an OSPF virtual link",
    options: [
      "To configure an OSPF virtual link",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 74,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question:
      "What is the purpose of the OSPF 'clear ip ospf process' command?",
    answer: "To reset the OSPF process",
    options: [
      "To reset the OSPF process",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 75,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question:
      "What is the purpose of the OSPF 'show ip ospf database' command?",
    answer: "To display the OSPF link-state database",
    options: [
      "To display the OSPF link-state database",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 76,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question: "What is the purpose of the OSPF 'show ip ospf route' command?",
    answer: "To display the OSPF routing table",
    options: [
      "To display the OSPF routing table",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 77,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question:
      "What is the purpose of the OSPF 'show ip ospf interface brief' command?",
    answer: "To display a brief summary of OSPF interfaces",
    options: [
      "To display a brief summary of OSPF interfaces",
      "To set OSPF router ID",
      "To set OSPF priority",
      "None of the above",
    ],
  },
  {
    id: 78,
    category: "Cybersecurity",
    subcategory: "Fundamentals",
    question:
      "What does confidentiality mean in the context of information security?",
    answer:
      "Ensuring that information is not disclosed to unauthorized individuals, entities, or processes",
    options: [
      "Ensuring information is protected from unauthorized access and disclosure",
      "Ensuring information is complete and unaltered",
      "Ensuring information and services are accessible when needed",
      "None of the above",
    ],
  },
  {
    id: 79,
    category: "Cybersecurity",
    subcategory: "Access Control",
    question: "How can you control access of personnel to a data center?",
    answer:
      "Implementing physical access controls such as biometric systems, key cards, and mantraps",
    options: [
      "Using strong passwords",
      "Installing antivirus software",
      "Implementing physical access controls such as biometric systems, key cards, and mantraps",
      "None of the above",
    ],
  },
  {
    id: 80,
    category: "Cybersecurity",
    subcategory: "Network Security",
    question: "What is the purpose of an air gap in cybersecurity?",
    answer:
      "To ensure a secure network is physically isolated from unsecured networks",
    options: [
      "To cool down the servers in a data center",
      "To ensure a secure network is physically isolated from unsecured networks",
      "To filter the air coming into the data center",
      "None of the above",
    ],
  },
  {
    id: 81,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question:
      "What command would you use to verify the OSPF process on a router?",
    answer: "show ip ospf",
    options: [
      "show ip ospf",
      "show ip route ospf",
      "show ospf database",
      "None of the above",
    ],
  },
  {
    id: 82,
    category: "CCNA",
    subcategory: "OSPF Commands",
    question: "Which OSPF command can show you the OSPF neighbors on a router?",
    answer: "show ip ospf neighbor",
    options: [
      "show ip ospf",
      "show ip ospf route",
      "show ip ospf neighbor",
      "None of the above",
    ],
  },
  {
    id: 83,
    category: "Cybersecurity",
    subcategory: "Control Categories",
    question: "Name three main control categories.",
    answer: "Preventive, Detective, and Corrective",
    options: [
      "Preventive, Detective, and Corrective",
      "Administrative, Technical, and Physical",
      "Mandatory, Discretionary, and Non-discretionary",
      "Operational, Managerial, and Executive",
    ],
  },
  {
    id: 84,
    category: "Physical Security",
    subcategory: "Security Controls",
    question: "Name three physical controls.",
    answer: "Fences, locks, and security guards",
    options: [
      "Fences, locks, and security guards",
      "Firewalls, IDS, and IPS",
      "Encryption, tokenization, and masking",
      "Policies, procedures, and guidelines",
    ],
  },
  {
    id: 85,
    category: "Incident Response",
    subcategory: "Incident Handling",
    question:
      "Following an incident, what type of control will be used when researching how the incident happened?",
    answer: "Detective control",
    options: [
      "Preventive control",
      "Detective control",
      "Corrective control",
      "Compensating control",
    ],
  },
  {
    id: 86,
    category: "Data Integrity",
    subcategory: "Security Fundamentals",
    question: "How do you know whether the integrity of your data is intact?",
    answer:
      "By verifying data has not been tampered with, using checksums, hashes, and digital signatures",
    options: [
      "By checking data availability",
      "By verifying data has not been tampered with, using checksums, hashes, and digital signatures",
      "By confirming data confidentiality",
      "By ensuring data redundancy",
    ],
  },
  {
    id: 87,
    category: "Cybersecurity",
    subcategory: "Control Types",
    question: "What is a corrective control?",
    answer:
      "A control that aims to mitigate or correct the impact of an incident",
    options: [
      "A control that prevents an incident from occurring",
      "A control that detects an ongoing incident",
      "A control that aims to mitigate or correct the impact of an incident",
      "A control that restores systems to normal after an incident",
    ],
  },
  {
    id: 88,
    category: "Network Security",
    subcategory: "Firewall Management",
    question: "What type of control is it when you change the firewall rules?",
    answer: "Preventive control",
    options: [
      "Corrective control",
      "Detective control",
      "Preventive control",
      "Compensating control",
    ],
  },
  {
    id: 89,
    category: "Authentication",
    subcategory: "Access Control",
    question:
      "What is used to log in to a system that works in conjunction with a PIN?",
    answer:
      "Two-factor authentication (something you know, and something you have)",
    options: [
      "Password authentication",
      "Biometric authentication",
      "Token-based authentication",
      "Two-factor authentication (something you know, and something you have)",
    ],
  },
  {
    id: 90,
    category: "React",
    subcategory: "React/MobX",
    question: "What is the purpose of makeAutoObservable in MobX?",
    answer:
      "It is used for automatically making all properties observable and actions of the class.",
    options: [
      "To observe changes in state",
      "To automatically make properties observable",
      "To mutate state directly",
      "To create new instances of the class",
    ],
  },
  {
    id: 91,
    category: "React",
    subcategory: "React/MobX",
    question: "What is the role of 'reaction' in MobX?",
    answer:
      "It is used to react to changes in observable data and to run side effects.",
    options: [
      "To initiate state",
      "To handle asynchronous actions",
      "To react to changes in data",
      "To replace Redux",
    ],
  },
  {
    id: 92,
    category: "CCNA",
    subcategory: "Ethernet Standards",
    question: "What does '1000BASE-T' represent?",
    answer:
      "Gigabit Ethernet, which operates at 1000 Mbps using baseband signaling over twisted pair cables.",
    options: [
      "Fast Ethernet",
      "Gigabit Ethernet",
      "Ethernet over Coaxial",
      "10 Gigabit Ethernet",
    ],
  },
  {
    id: 93,
    category: "React",
    subcategory: "React/MobX",
    question: "What is the significance of 'runInAction' in MobX?",
    answer:
      "It is used for modifying the state within an asynchronous action or reaction.",
    options: [
      "To run all actions sequentially",
      "To dispatch an action",
      "To modify the state in an action",
      "To create a new store",
    ],
  },
  {
    id: 94,
    category: "CCNA",
    subcategory: "Ethernet Standards",
    question: "What is '100BASE-T' commonly known as?",
    answer:
      "Fast Ethernet, transmitting at 100 Mbps using baseband signaling and twisted pair cables.",
    options: [
      "Standard Ethernet",
      "Fast Ethernet",
      "Gigabit Ethernet",
      "10 Gigabit Ethernet",
    ],
  },
  {
    id: 95,
    category: "CCNA",
    subcategory: "Ethernet Standards",
    question: "What does '10BASE-T' stand for in networking?",
    answer:
      "An Ethernet standard that transmits at 10 Mbps, uses baseband signaling, and twisted pair cables.",
    options: [
      "10 Mbps Baseband, Twisted pair",
      "10 Mbps Broadband, Coaxial",
      "100 Mbps Baseband, Twisted pair",
      "1000 Mbps Baseband, Twisted pair",
    ],
  },
  {
    id: 96,
    category: "CCNA",
    subcategory: "Ethernet Standards",
    question: "What does '1000BASE-T' represent?",
    answer:
      "Gigabit Ethernet, which operates at 1000 Mbps using baseband signaling over twisted pair cables.",
    options: [
      "Fast Ethernet",
      "Gigabit Ethernet",
      "Ethernet over Coaxial",
      "10 Gigabit Ethernet",
    ],
  },
  {
    id: 97,
    category: "CCNA",
    subcategory: "Ethernet Categories",
    question: "What speed does Fast Ethernet support?",
    answer: "Fast Ethernet supports 100 Mbps.",
    options: ["10 Mbps", "100 Mbps", "1000 Mbps", "10 Gbps"],
  },
  {
    id: 98,
    category: "CCNA",
    subcategory: "Ethernet Categories",
    question: "What is the speed of Gigabit Ethernet?",
    answer: "Gigabit Ethernet supports speeds of 1000 Mbps or 1 Gbps.",
    options: ["100 Mbps", "1000 Mbps", "10 Gbps", "100 Gbps"],
  },
  {
    id: 99,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What is the purpose of the 'interface type port-number' command in Cisco IOS?",
    answer:
      "It is used to enter the interface configuration mode for a specific port, like 'FastEthernet 0/1'.",
    options: [
      "To configure global settings",
      "To set the hostname",
      "To enter interface configuration mode",
      "To save the current configuration",
    ],
  },
  {
    id: 100,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does the 'hostname name' command do in Cisco IOS?",
    answer:
      "It sets the device's hostname, used as part of the command prompt.",
    options: [
      "To display the device's hostname",
      "To set the device's hostname",
      "To enter hostname configuration mode",
      "To revert to the default hostname",
    ],
  },
  {
    id: 101,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the function of the 'exit' command in Cisco IOS?",
    answer:
      "It exits the current configuration mode and returns to the higher configuration mode.",
    options: [
      "To log out of the device",
      "To exit the current mode",
      "To restart the device",
      "To display exit options",
    ],
  },
  {
    id: 102,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the effect of the 'end' command in Cisco IOS?",
    answer:
      "It exits any configuration mode and returns to the privileged EXEC mode.",
    options: [
      "To end the current session",
      "To save the configuration",
      "To exit to privileged EXEC mode",
      "To show the running configuration",
    ],
  },
  {
    id: 103,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does 'Ctrl+Z' do in Cisco IOS?",
    answer:
      "It exits the configuration mode and returns to the privileged EXEC mode.",
    options: [
      "To cancel the last command",
      "To suspend the current process",
      "To exit to privileged EXEC mode",
      "To restart the device",
    ],
  },
  {
    id: 104,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does the 'line console 0' command configure in Cisco IOS?",
    answer: "It is used to configure the console line parameters.",
    options: [
      "To configure the first console port",
      "To configure virtual terminal lines",
      "To display line console settings",
      "To configure the console line parameters",
    ],
  },
  {
    id: 105,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the purpose of the 'login' command in Cisco IOS?",
    answer:
      "It tells IOS to prompt for a password on the console or vty lines.",
    options: [
      "To log into a remote device",
      "To enable password checking",
      "To create a new user account",
      "To prompt for a password on console/vty lines",
    ],
  },
  {
    id: 106,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does the 'password value' command do in Cisco IOS?",
    answer: "It sets the password for the line where it is configured.",
    options: [
      "To change the enable password",
      "To set a password for the line",
      "To display the password settings",
      "To encrypt all plaintext passwords",
    ],
  },
  {
    id: 107,
    category: "Cybersecurity",
    subcategory: "Asymmetric Algorithms",
    question: "What is the primary purpose of Diffie-Hellman key exchange?",
    answer:
      "To securely generate a shared secret between two parties over an insecure channel, which can be used for symmetric encryption.",
    options: [
      "To encrypt and decrypt messages",
      "To generate a shared secret",
      "To sign digital certificates",
      "To authenticate users",
    ],
  },
  {
    id: 108,
    category: "Cybersecurity",
    subcategory: "Asymmetric Algorithms",
    question: "What is RSA commonly used for in cybersecurity?",
    answer:
      "RSA is used for encrypting data, securing communications, and digitally signing documents.",
    options: [
      "For hashing functions",
      "For symmetric key encryption",
      "For encrypting data and digital signatures",
      "For network routing",
    ],
  },
  {
    id: 109,
    category: "Cybersecurity",
    subcategory: "Asymmetric Algorithms",
    question:
      "What is the advantage of using Elliptic Curve Cryptography (ECC) over RSA?",
    answer:
      "ECC provides the same level of security as RSA but with smaller key sizes, making it more efficient, especially for use in mobile devices.",
    options: [
      "Faster hash computations",
      "Smaller key sizes with equivalent security",
      "Larger key sizes for better security",
      "Easier implementation",
    ],
  },
  {
    id: 110,
    category: "Cybersecurity",
    subcategory: "Asymmetric Algorithms",
    question: "What is the significance of ephemeral keys in cryptography?",
    answer:
      "Ephemeral keys enhance security by being used for a single session only, reducing the risk of long-term key compromise and subsequent decryption of intercepted communications.",
    options: [
      "They are easier to generate",
      "They provide long-term security",
      "They reduce the risk of key compromise",
      "They are used for digital signatures",
    ],
  },
  {
    id: 111,
    category: "Cybersecurity",
    subcategory: "Asymmetric Algorithms",
    question:
      "What is the role of Pretty Good Privacy (PGP) in secure communications?",
    answer:
      "PGP is used to encrypt and decrypt texts, emails, files, directories, and whole disk partitions to increase the security of email communications.",
    options: [
      "To create secure network tunnels",
      "To encrypt and decrypt communications",
      "To manage passwords",
      "To detect network intrusions",
    ],
  },
  {
    id: 112,
    category: "Cybersecurity",
    subcategory: "Symmetric Algorithms",
    question:
      "What is the Advanced Encryption Standard (AES) primarily used for?",
    answer:
      "AES is used for securing sensitive but unclassified material by U.S. government agencies and, as a likely consequence, became the most used algorithm in symmetric key cryptography.",
    options: [
      "Digital signatures",
      "Key exchange",
      "Secure hashing",
      "Encrypting data",
    ],
  },
  {
    id: 113,
    category: "Cybersecurity",
    subcategory: "Symmetric Algorithms",
    question: "What key lengths does AES support?",
    answer: "AES supports key lengths of 128, 192, and 256 bits.",
    options: [
      "64 and 128 bits",
      "128, 192, and 256 bits",
      "256 and 512 bits",
      "1024 and 2048 bits",
    ],
  },
  {
    id: 114,
    category: "Cybersecurity",
    subcategory: "Symmetric Algorithms",
    question: "What is Data Encryption Standard (DES) known for?",
    answer:
      "DES is known as an outdated encryption algorithm due to its 56-bit key size, which is now considered to be insecure against brute-force attacks.",
    options: [
      "Its strong 256-bit key",
      "Its use in blockchain technology",
      "Being outdated and insecure",
      "Its speed in encrypting data",
    ],
  },
  {
    id: 115,
    category: "Cybersecurity",
    subcategory: "Symmetric Algorithms",
    question: "How does Triple DES enhance the security of DES?",
    answer:
      "Triple DES applies the DES encryption process three times using two or three keys to increase security.",
    options: [
      "By using a larger block size",
      "By encrypting data three times",
      "By employing asymmetric encryption",
      "By implementing a faster algorithm",
    ],
  },
  {
    id: 116,
    category: "Cybersecurity",
    subcategory: "Symmetric Algorithms",
    question: "What is the main reason for the discouragement of using RC4?",
    answer:
      "RC4 is discouraged due to vulnerabilities that make it susceptible to several types of attacks, such as the Key Reuse Attack.",
    options: [
      "Its slow performance",
      "Its complex key management",
      "Its susceptibility to attacks",
      "Its large key size requirement",
    ],
  },
  {
    id: 117,
    category: "Cybersecurity",
    subcategory: "Symmetric Algorithms",
    question: "What is Blowfish primarily used for?",
    answer:
      "Blowfish is used for encrypting data and is known for its speed and the fact that it remains unpatented and license-free.",
    options: [
      "Encrypting data quickly and securely",
      "Exchanging keys",
      "Generating hash functions",
      "Creating digital signatures",
    ],
  },
  {
    id: 118,
    category: "Cybersecurity",
    subcategory: "Symmetric Algorithms",
    question: "What are the characteristics of Twofish?",
    answer:
      "Twofish is a symmetric key block cipher with a block size of 128 bits and key sizes up to 256 bits, known for its flexibility and security.",
    options: [
      "128-bit block size, up to 256-bit keys",
      "64-bit block size, fixed key length",
      "256-bit block size, variable key length",
      "1024-bit block size for high security",
    ],
  },
  {
    id: 119,
    category: "Cybersecurity",
    subcategory: "Encryption",
    question: "What is the purpose of XOR encryption when used with AES?",
    answer:
      "XOR encryption is used in combination with AES to apply a one-time pad, which is a simple and effective method for certain encryption scenarios.",
    options: [
      "To encrypt data one byte at a time",
      "To create a one-time pad for encryption",
      "For key exchange mechanisms",
      "To generate hash functions",
    ],
  },
  {
    id: 120,
    category: "Cybersecurity",
    subcategory: "Key Stretching Algorithms",
    question: "What is key stretching and how does BCRYPT apply it?",
    answer:
      "Key stretching strengthens passwords by appending random characters to increase size and complexity, with BCRYPT additionally salting the passwords.",
    options: [
      "It encrypts passwords with Blowfish",
      "It compresses passwords for storage",
      "It appends characters to strengthen passwords",
      "It creates keys for symmetric encryption",
    ],
  },
  {
    id: 121,
    category: "Cybersecurity",
    subcategory: "Key Stretching Algorithms",
    question: "What does PBKDF2 do and how does it enhance security?",
    answer:
      "PBKDF2 enhances password security by using a salt and iterating the hash process to protect against rainbow table attacks.",
    options: [
      "It encrypts passwords with a single iteration",
      "It hashes passwords without a salt",
      "It uses a salt and iterations to secure passwords",
      "It generates asymmetric keys",
    ],
  },
  {
    id: 122,
    category: "Cybersecurity",
    subcategory: "Password Security",
    question: "What is 'salting' in the context of password security?",
    answer:
      "Salting involves appending random characters to a password before it is hashed to increase complexity and protect against brute force attacks.",
    options: [
      "Encrypting a password",
      "Compressing password data",
      "Appending random characters before hashing",
      "Storing passwords in plaintext",
    ],
  },
  {
    id: 123,
    category: "Cybersecurity",
    subcategory: "Cipher Modes",
    question: "What is the main difference between stream and block ciphers?",
    answer:
      "Stream ciphers encrypt data one bit at a time, while block ciphers encrypt data in fixed-size blocks, such as 128 bits at a time.",
    options: [
      "Stream ciphers use keys; block ciphers do not",
      "Stream ciphers are faster than block ciphers",
      "Block ciphers encrypt fixed-size blocks; stream ciphers do bit by bit",
      "Block ciphers are used for data at rest; stream ciphers for data in transit",
    ],
  },

  {
    id: 124,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does the command 'show mac address-table' display in a Cisco switch?",
    answer: "Shows all MAC table entries of all types.",
    options: [
      "Shows only static MAC table entries",
      "Shows all dynamically learned MAC table entries",
      "Clears the MAC address table",
      "Shows all MAC table entries of all types",
    ],
  },
  {
    id: 125,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does the command 'show mac address-table dynamic' display in a Cisco switch?",
    answer: "Shows all dynamically learned MAC table entries.",
    options: [
      "Shows all MAC table entries of all types",
      "Shows all statically configured MAC addresses",
      "Shows all dynamically learned MAC table entries",
      "Displays the MAC address aging time",
    ],
  },

  {
    id: 126,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What is the purpose of the 'show mac address-table dynamic vlan vlan-id' command?",
    answer: "Shows all dynamically learned MAC table entries in that VLAN.",
    options: [
      "Shows a static list of MAC addresses for a VLAN",
      "Shows all dynamically learned MAC table entries in that VLAN",
      "Displays MAC address table aging time for a VLAN",
      "Clears dynamic MAC addresses for a specific VLAN",
    ],
  },
  {
    id: 127,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does 'show mac address-table dynamic address mac-address' do?",
    answer:
      "Shows the dynamically learned MAC table entries with that MAC address.",
    options: [
      "Displays all MAC addresses associated with a VLAN",
      "Shows the dynamically learned MAC table entries with that MAC address",
      "Lists MAC address table entries for a specific interface",
      "Empties the MAC table of dynamic entries",
    ],
  },
  {
    id: 128,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does the 'show mac address-table dynamic interface interface-id' command show?",
    answer:
      "Shows all dynamically learned MAC table entries associated with that interface.",
    options: [
      "Displays the MAC address table size and empty slots",
      "Shows all MAC table entries of all types",
      "Shows all dynamically learned MAC table entries associated with that interface",
      "Shows global and per-VLAN MAC table entries",
    ],
  },
  {
    id: 129,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What information does 'show mac address-table count' provide?",
    answer:
      "Shows the number of entries in the MAC table and the total number of remaining empty slots in the MAC table.",
    options: [
      "Shows the number of dynamic entries in the MAC table",
      "Shows the aging time of MAC table entries",
      "Shows the number of entries in the MAC table and the total number of remaining empty slots in the MAC table",
      "Clears the MAC address table of dynamic entries",
    ],
  },
  {
    id: 130,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the output of 'show mac address-table'?",
    answer: "Shows the global and per-VLAN MAC table entries.",
    options: [
      "Shows the global and per-VLAN MAC table entries",
      "Displays the dynamic MAC addresses for a specific VLAN",
      "Lists the MAC addresses statically configured on the switch",
      "Displays the MAC address table size and empty slots",
    ],
  },

  {
    id: 131,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does the command 'line console 0' accomplish in a Cisco switch?",
    answer: "Changes the context to console configuration mode.",
    options: [
      "Changes the context to console configuration mode.",
      "Shows the running configuration in console mode.",
      "Resets the console line settings.",
      "Sets the console line password.",
    ],
  },
  {
    id: 132,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the purpose of 'line vty 0 4' in a Cisco switch?",
    answer:
      "Changes the context to vty configuration mode for the range of vty lines listed in the command.",
    options: [
      "Shows the vty line status.",
      "Configures the IP address for vty lines.",
      "Changes the context to vty configuration mode for the range of vty lines listed in the command.",
      "Clears the vty line configurations.",
    ],
  },
  {
    id: 133,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does the 'login' command do when entered in line configuration mode?",
    answer: "Tells IOS to prompt for a password.",
    options: [
      "Tells IOS to prompt for a password.",
      "Logs the current user out of the switch.",
      "Displays a login banner message.",
      "Configures a login banner.",
    ],
  },
  {
    id: 134,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What is the function of the 'enable secret pass-value' command in a Cisco switch?",
    answer:
      "Sets this switch's password that is required for any user to reach enable mode.",
    options: [
      "Sets the password for the current line.",
      "Sets this switch's password that is required for any user to reach enable mode.",
      "Displays the secret password of the switch.",
      "Configures a secret password for SSH access only.",
    ],
  },
  {
    id: 135,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does the 'history size length' command do?",
    answer:
      "Defines the number of commands held in the history buffer, for later recall, for users of those lines.",
    options: [
      "Sets the length of the console cable.",
      "Defines the number of commands to display in the running configuration.",
      "Configures the switch's buffer size for storing logs.",
      "Defines the number of commands held in the history buffer, for later recall, for users of those lines.",
    ],
  },
  {
    id: 136,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the purpose of the 'logging synchronous' command?",
    answer:
      "Tells IOS to send log messages to the user at natural breakpoints between commands rather than in the middle of a line of output.",
    options: [
      "Enables synchronous logging for better log tracking.",
      "Disables all logging mechanisms on the switch.",
      "Synchronizes logging information with a remote server.",
      "Tells IOS to send log messages to the user at natural breakpoints between commands rather than in the middle of a line of output.",
    ],
  },
  {
    id: 137,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does the 'exec-timeout' command accomplish?",
    answer:
      "Sets the inactivity timeout, so that after the defined period of no action, IOS closes the current user login session.",
    options: [
      "Executes a command after a set timeout period.",
      "Sets the inactivity timeout, so that after the defined period of no action, IOS closes the current user login session.",
      "Determines how long an executed command will run before termination.",
      "Schedules a command to be executed after a certain period.",
    ],
  },
  {
    id: 138,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does the 'interface type port-number' command do?",
    answer:
      "Changes context to interface mode for the specified port number, such as Fast Ethernet or Gigabit Ethernet.",
    options: [
      "Assigns an IP address to an interface type and port number.",
      "Changes context to interface mode for the specified port number, such as Fast Ethernet or Gigabit Ethernet.",
      "Displays the interface type and port number status.",
      "Configures the VLAN for the specified interface type and port number.",
    ],
  },
  {
    id: 139,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What is the purpose of the 'interface range type port-number - end-port-number' command?",
    answer:
      "Changes the context to interface mode for a range of consecutively numbered interfaces, allowing batch configuration.",
    options: [
      "Shows a range of interfaces and their types.",
      "Changes the context to interface mode for a range of consecutively numbered interfaces, allowing batch configuration.",
      "Tests connectivity for a range of interfaces.",
      "Shuts down a range of interfaces.",
    ],
  },
  {
    id: 140,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does the 'shutdown' command accomplish when used in interface mode?",
    answer: "Disables the interface.",
    options: [
      "Disables the interface.",
      "Restarts the interface.",
      "Shuts down and then immediately restarts the interface.",
      "Displays the shutdown status of the interface.",
    ],
  },
  {
    id: 141,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the function of the 'speed' command in interface mode?",
    answer:
      "Manually sets the speed of the interface or enables the interface to automatically negotiate the speed.",
    options: [
      "Checks the current speed of the interface.",
      "Limits the speed of data transfer across the interface.",
      "Manually sets the speed of the interface or enables the interface to automatically negotiate the speed.",
      "Tests the speed and functionality of the interface.",
    ],
  },
  {
    id: 142,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is the effect of the 'duplex' command in interface mode?",
    answer:
      "Manually sets the duplex mode to half or full, or configures the interface to autonegotiate the duplex setting.",
    options: [
      "Checks the duplex mode of all interfaces on the switch.",
      "Automatically determines the best duplex mode for the interface.",
      "Manually sets the duplex mode to half or full, or configures the interface to autonegotiate the duplex setting.",
      "Disables duplexing on the interface.",
    ],
  },
  {
    id: 143,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What is the effect of using the 'no duplex' command on a Cisco switch interface?",
    answer:
      "Reverts to the default setting for duplex, which is auto-negotiation.",
    options: [
      "Disables duplexing on the interface.",
      "Sets the duplex mode to half-duplex.",
      "Reverts to the default setting for duplex, which is auto-negotiation.",
      "Sets the duplex mode to full-duplex.",
    ],
  },
  {
    id: 144,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What does the 'no speed' command do when configured on an interface?",
    answer: "Reverts to the default speed setting, which is auto-negotiation.",
    options: [
      "Sets the interface speed to the highest available speed.",
      "Disables the interface.",
      "Reverts to the default speed setting, which is auto-negotiation.",
      "Removes any speed restrictions on the interface.",
    ],
  },
  {
    id: 145,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What happens when you enter 'no description' on a Cisco switch interface?",
    answer: "Removes any previously configured description on the interface.",
    options: [
      "Removes any previously configured description on the interface.",
      "Sets a default description for the interface.",
      "Hides the interface description from the running configuration.",
      "Prevents any future descriptions from being added to the interface.",
    ],
  },
  {
    id: 146,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question:
      "What information does the 'show mac address-table dynamic' command display?",
    answer:
      "Lists the dynamically learned entries in the switch's MAC address table, with subsets by interface and/or VLAN.",
    options: [
      "Displays the entire MAC address table, including static and dynamic entries.",
      "Lists the dynamically learned entries in the switch's MAC address table, with subsets by interface and/or VLAN.",
      "Shows only the static entries in the MAC address table.",
      "Clears dynamic entries from the MAC address table.",
    ],
  },
  {
    id: 147,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What is shown by the 'show interfaces status' command?",
    answer:
      "Lists one output line per interface, including the description, operating state, and settings for duplex and speed.",
    options: [
      "Lists all configured IP addresses on each interface.",
      "Shows the up or down status of all interfaces on the switch.",
      "Lists one output line per interface, including the description, operating state, and settings for duplex and speed.",
      "Displays the packet statistics for each interface.",
    ],
  },
  {
    id: 148,
    category: "CCNA",
    subcategory: "Cisco Commands",
    question: "What does the 'show interfaces description' command display?",
    answer:
      "Displays one line of information per interface, with a two-item status and includes any description that is configured on the interfaces.",
    options: [
      "Displays the IP configuration of each interface.",
      "Displays one line of information per interface, with a two-item status and includes any description that is configured on the interfaces.",
      "Shows the packet statistics for each interface.",
      "Lists the MAC address table entries for each interface.",
    ],
  },
  {
    id: 149,
    category: "CCNA",
    subcategory: "Spanning Tree Protocol",
    question: "What is the STP cost for a 10 Mbps network connection?",
    answer: "The STP cost for a 10 Mbps network connection is 100.",
    options: [
      "The STP cost for a 10 Mbps network connection is 1.",
      "The STP cost for a 10 Mbps network connection is 10.",
      "The STP cost for a 10 Mbps network connection is 100.",
      "The STP cost for a 10 Mbps network connection is 19.",
    ],
  },
  {
    id: 150,
    category: "CCNA",
    subcategory: "Spanning Tree Protocol",
    question: "What is the STP cost for a 100 Mbps network connection?",
    answer: "The STP cost for a 100 Mbps network connection is 19.",
    options: [
      "The STP cost for a 100 Mbps network connection is 4.",
      "The STP cost for a 100 Mbps network connection is 100.",
      "The STP cost for a 100 Mbps network connection is 2.",
      "The STP cost for a 100 Mbps network connection is 19.",
    ],
  },
  {
    id: 151,
    category: "CCNA",
    subcategory: "Spanning Tree Protocol",
    question: "What is the STP cost for a 1 Gbps network connection?",
    answer: "The STP cost for a 1 Gbps network connection is 4.",
    options: [
      "The STP cost for a 1 Gbps network connection is 100.",
      "The STP cost for a 1 Gbps network connection is 4.",
      "The STP cost for a 1 Gbps network connection is 19.",
      "The STP cost for a 1 Gbps network connection is 2.",
    ],
  },
  {
    id: 152,
    category: "CCNA",
    subcategory: "Spanning Tree Protocol",
    question: "What is the STP cost for a 10 Gbps network connection?",
    answer: "The STP cost for a 10 Gbps network connection is 2.",
    options: [
      "The STP cost for a 10 Gbps network connection is 19.",
      "The STP cost for a 10 Gbps network connection is 4.",
      "The STP cost for a 10 Gbps network connection is 2.",
      "The STP cost for a 10 Gbps network connection is 1.",
    ],
  },
  {
    id: 153,
    category: "CCNA",
    subcategory: "VLAN Configuration",
    question: "What is the purpose of the 'vlan vlan-id' command in Cisco IOS?",
    answer:
      "It is a global config command that both creates the VLAN and puts the CLI into VLAN configuration mode.",
    options: [
      "It assigns the VLAN to a specific interface.",
      "It shows the current configuration of the specified VLAN.",
      "It is a global config command that both creates the VLAN and puts the CLI into VLAN configuration mode.",
      "It deletes the specified VLAN from the switch.",
    ],
  },
  {
    id: 154,
    category: "CCNA",
    subcategory: "VLAN Configuration",
    question:
      "What does the 'name vlan-name' command do within VLAN configuration mode?",
    answer: "It is a VLAN subcommand that names the VLAN.",
    options: [
      "It is a VLAN subcommand that names the VLAN.",
      "It defines the name of the switch device.",
      "It assigns a name to an interface associated with the VLAN.",
      "It lists all VLAN names configured on the switch.",
    ],
  },
  {
    id: 155,
    category: "CCNA",
    subcategory: "VLAN Configuration",
    question:
      "What is the function of the '[no] shutdown vlan vlan-id' command?",
    answer:
      "It is a global config command that enables (no shutdown) or disables (shutdown) the VLAN.",
    options: [
      "It reboots the VLAN interface.",
      "It is used to restart the VTP process on the switch.",
      "It is a global config command that enables (no shutdown) or disables (shutdown) the VLAN.",
      "It saves the VLAN configuration to the startup configuration.",
    ],
  },
  {
    id: 156,
    category: "CCNA",
    subcategory: "VTP Configuration",
    question:
      "What does the 'vtp mode {server | client | transparent | off}' command accomplish?",
    answer:
      "It is a global config command that defines the VLAN Trunking Protocol (VTP) mode.",
    options: [
      "It checks the status of VTP on the switch.",
      "It is a global config command that defines the VLAN Trunking Protocol (VTP) mode.",
      "It configures the switch to forward VTP advertisements.",
      "It disables VTP completely on the switch.",
    ],
  },
  {
    id: 157,
    category: "CCNA",
    subcategory: "Trunk Configuration",
    question:
      "What is the purpose of the 'switchport mode {access | dynamic {auto | desirable} | trunk}' command?",
    answer:
      "It is an interface subcommand that configures the trunking mode of a switchport.",
    options: [
      "It sets the speed of the switchport.",
      "It configures the security mode of the switchport.",
      "It assigns the switchport to a specific VLAN.",
      "It is an interface subcommand that configures the trunking mode of a switchport.",
    ],
  },
];

export default SAMPLE_FLASHCARDS;
